// Generated by scripts/build-ui-icons.mjs.
export { Magnet } from "./glyphs-5";
export { EnvelopeSimple as Mail } from "./glyphs-3";
export { EnvelopeSimpleOpen as MailPlus } from "./glyphs-3";
export { MapTrifold as Map } from "./glyphs-5";
export { MapPin } from "./glyphs-5";
export { MapPin as MapPinIcon } from "./glyphs-5";
export { CornersOut as Maximize } from "./glyphs-3";
export { ArrowsOut as Maximize2 } from "./glyphs-1";
export { Megaphone } from "./glyphs-5";
export { List as Menu } from "./glyphs-5";
export { List as MenuIcon } from "./glyphs-5";
export { ChatCircle as MessageCircle } from "./glyphs-2";
export { ChatCircleDots as MessageCircleQuestion } from "./glyphs-2";
export { ChatCircle as MessageSquare } from "./glyphs-2";
export { ChatCircleDots as MessageSquareWarning } from "./glyphs-2";
export { Microphone as Mic } from "./glyphs-5";
export { ArrowsIn as Minimize2 } from "./glyphs-1";
export { Minus } from "./glyphs-5";
export { Monitor } from "./glyphs-5";
export { Moon } from "./glyphs-5";
export { DotsThree as MoreHorizontal } from "./glyphs-3";
export { DotsThreeVertical as MoreVertical } from "./glyphs-3";
export { CursorClick as MousePointerClick } from "./glyphs-3";
export { ArrowsOutCardinal as Move } from "./glyphs-1";
export { MusicNote as Music2 } from "./glyphs-5";
export { Newspaper } from "./glyphs-5";
export { Package } from "./glyphs-5";
export { Palette } from "./glyphs-5";
export { SidebarSimple as PanelLeft } from "./glyphs-6";
export { SidebarSimple as PanelLeftClose } from "./glyphs-6";
export { Paperclip } from "./glyphs-5";
export { Pause } from "./glyphs-5";
export { PauseCircle } from "./glyphs-5";
export { Pen } from "./glyphs-6";
export { Pen as PenLine } from "./glyphs-6";
export { PenNib as PenTool } from "./glyphs-6";
export { PencilSimple as Pencil } from "./glyphs-6";
export { PencilSimpleLine as PencilLine } from "./glyphs-6";
export { Phone } from "./glyphs-6";
export { PhoneX as PhoneMissed } from "./glyphs-6";
export { PushPin as Pin } from "./glyphs-6";
export { PushPinSlash as PinOff } from "./glyphs-6";
export { Play } from "./glyphs-6";
export { PlayCircle } from "./glyphs-6";
export { Plug } from "./glyphs-6";
export { Plus } from "./glyphs-6";
export { Presentation } from "./glyphs-6";
export { Quotes as Quote } from "./glyphs-6";
export { Broadcast as Radar } from "./glyphs-1";
export { Rectangle as RectangleHorizontal } from "./glyphs-6";
export { ArrowBendUpRight as Redo2 } from "./glyphs-1";
export { ArrowsClockwise as RefreshCw } from "./glyphs-1";
export { ArrowCounterClockwise as RotateCcw } from "./glyphs-1";
export { ArrowClockwise as RotateCw } from "./glyphs-1";
export { FloppyDisk as Save } from "./glyphs-4";
export { Scales as Scale } from "./glyphs-6";
export { Scan as ScanLine } from "./glyphs-6";
export { Scissors } from "./glyphs-6";
export { Scroll as ScrollText } from "./glyphs-6";
export { MagnifyingGlass as Search } from "./glyphs-5";
export { MagnifyingGlass as SearchIcon } from "./glyphs-5";
export { PaperPlaneTilt as Send } from "./glyphs-5";
export { Gear as Settings } from "./glyphs-4";
export { SlidersHorizontal as Settings2 } from "./glyphs-7";
export { ShareNetwork as Share2 } from "./glyphs-6";
export { Shield } from "./glyphs-6";
export { ShieldWarning as ShieldAlert } from "./glyphs-6";
export { ShieldCheck } from "./glyphs-6";
export { Question as ShieldQuestion } from "./glyphs-6";
export { ShoppingBag } from "./glyphs-6";
export { ShoppingCart } from "./glyphs-6";
export { SlidersHorizontal } from "./glyphs-7";
export { DeviceMobile as Smartphone } from "./glyphs-3";
export { Smiley as SmileIcon } from "./glyphs-7";
export { TextAlignLeft as Space } from "./glyphs-7";
export { Sparkle as Sparkles } from "./glyphs-7";
export { Square } from "./glyphs-7";
export { CheckSquare as SquareCheck } from "./glyphs-2";
export { Star } from "./glyphs-7";
export { Note as StickyNote } from "./glyphs-5";
export { Storefront as Store } from "./glyphs-7";
export { Sun } from "./glyphs-7";
export { Tag } from "./glyphs-7";
export { Tag as Tags } from "./glyphs-7";
export { Target } from "./glyphs-7";
export { Textbox as TextCursorInput } from "./glyphs-7";
export { Timer } from "./glyphs-7";
export { ToggleLeft } from "./glyphs-7";
export { Trash as Trash2 } from "./glyphs-7";
export { TrendDown as TrendingDown } from "./glyphs-7";
export { TrendUp as TrendingUp } from "./glyphs-7";
export { Warning as TriangleAlert } from "./glyphs-8";
export { Trophy } from "./glyphs-7";
export { TextT as Type } from "./glyphs-7";
export { ArrowBendUpLeft as Undo2 } from "./glyphs-1";
export { Plug as Unplug } from "./glyphs-6";
export { UploadSimple as Upload } from "./glyphs-7";
export { CloudArrowUp as UploadCloud } from "./glyphs-2";
export { User } from "./glyphs-7";
export { UserCheck } from "./glyphs-7";
export { UserCircle } from "./glyphs-8";
export { UserCircle as UserCircle2 } from "./glyphs-8";
export { UserMinus } from "./glyphs-8";
export { UserPlus } from "./glyphs-8";
export { User as UserRound } from "./glyphs-7";
export { Users } from "./glyphs-8";
export { UsersThree as Users2 } from "./glyphs-8";
export { UsersThree as UsersRound } from "./glyphs-8";
export { ForkKnife as Utensils } from "./glyphs-4";
export { VideoCamera as Video } from "./glyphs-8";
export { SpeakerHigh as Volume2 } from "./glyphs-7";
export { SpeakerSlash as VolumeX } from "./glyphs-7";
export { Wrench } from "./glyphs-8";
export { X } from "./glyphs-8";
export { XCircle } from "./glyphs-8";
export { X as XIcon } from "./glyphs-8";
export { MagnifyingGlassPlus as ZoomIn } from "./glyphs-5";
export { MagnifyingGlassMinus as ZoomOut } from "./glyphs-5";
